(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('WikiSpaceDialogController', WikiSpaceDialogController);

    WikiSpaceDialogController.$inject = ['$scope', 'entity', '$uibModalInstance', 'WikiSpace'];

    function WikiSpaceDialogController($scope, entity, $uibModalInstance, WikiSpace) {
        var vm = this;
        vm.space = entity;
        vm.clear = clear;
        vm.save = save;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.space.id !== null) {
                WikiSpace.update(vm.space, onSaveSuccess, onSaveError);
            } else {
                WikiSpace.save(vm.space, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('chamadosApp:wikiSpaceUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }
    }
})();
